import { App } from "@/model/App";

export interface StateApp {
  app: App;
  appStatusSave: StateSaveApp;
  appStatusEdit: StateEditApp;
  appStatusRemove: StateRemoveApp;
  appStatusReport: StateReportApp;
  appStatusSearch:StateSearchApp;
  apps: App[];
  facetsSelected: string[];
  facets: string[];
  showMainComponent: ShowMain;
}

export interface PayloadSaveApp {
  app: App;
  sessionId: string;
}

export interface PayloadEditApp {
  appUpdated: App;
  sessionId: string;
}

export interface ShowMain {
  showHome: boolean;
  showRes: boolean;
}

export interface PayloadRemoveApp {
  appName: string;
  sessionId: string;
}

export interface PayloadReportApp {
  appName: string;
  cause: string;
  comments: string;
  informerEmail: string;
}

export interface PayloadFacets {
  appName: string;
  facetsSelected: string[];
}

export enum StateSaveApp {
  initial,
  loading,
  success,
  fail,
}

export enum StateRemoveApp {
  initial,
  loading,
  success,
  fail,
}

export enum StateReportApp {
  initial,
  loading,
  success,
  fail,
}

export enum StateEditApp {
  initial,
  loading,
  success,
  fail,
}
export enum StateSearchApp {
  loading,
  fail,
  success
}
